<template>
  <div class="mb-16" style="height: 80vh">
    <v-row class="mr-4 ml-4 mt-2">
      <v-col cols="7">
      </v-col>
      <v-col class="mr-3" style="background-color: rgba(0,0,0,0.05); border-radius: 10px" cols="2">
        <v-row>
          <v-col>
            <v-text-field
                @change="react()"
                v-model="xRange.min"
                density="compact"
                hide-details
                label="min"
                prepend-inner-icon="mdi-arrow-left"
                color="primary"
            >
            </v-text-field>
          </v-col>
          <v-col>
            <v-text-field
                @change="react()"
                v-model="xRange.max"
                density="compact"
                hide-details
                label="max"
                prepend-inner-icon="mdi-arrow-right"
                color="primary"
            >
            </v-text-field>
          </v-col>
        </v-row>

      </v-col>
      <v-col style="background-color: rgba(0,0,0,0.05); border-radius: 10px" cols="2">
        <v-row>
          <v-col>
            <v-text-field
                @change="react()"
                v-model="yRange.max"
                density="compact"
                hide-details
                label="max"
                prepend-inner-icon="mdi-arrow-up"
                color="primary"
            >
            </v-text-field>
          </v-col>
          <v-col>
            <v-text-field
                @change="react()"
                v-model="yRange.min"
                density="compact"
                hide-details
                label="min"
                prepend-inner-icon="mdi-arrow-down"
                color="primary"
            >
            </v-text-field>
          </v-col>

        </v-row>
      </v-col>
    </v-row>
    <v-row style="height: 100%">
      <v-col class="pt-0" style="width: 100%" >
        <div style="width: 100%" ref="plot" id="plot"></div>

      </v-col>
    </v-row>
  </div>
</template>

<script>
import Plotly from 'plotly.js-dist'
import {dikeProfileData} from "@/assets/test_dike_profiles";

export default {
  name: "TestView",
  components: {},
  data: () => ({
    showMarkers: false,
    previousSelection: null,
    dikeProfileData: dikeProfileData,
    xRange: {
      min: -100,
      max: 100
    },
    yRange: {
      min: -5,
      max: 20
    },
    baseLine: {
      width: 1,
      dash: 'dash',
    },
    hoverLine: {
      width: 4,
      dash: 'solid',
    },
    format: {
      x: [],
      y: [],
      mode: 'lines+text',
      type: 'scatter',
      name: null,
      textfont: {
        family: 'Roboto'
      },
    }
  }),
  computed: {
    layout() {
      return {
        legend: {
          x: 0,
          y: 1.0
        },
        xaxis: {
          range: [this.xRange.min, this.xRange.max],
          type: 'linear'
        },
        yaxis: {
          range: [this.yRange.min, this.yRange.max],
          type: 'linear'
        }
      }
    },
    dikeProfilesElevation() {
      let dikeProfilesPlot = []
      this.dikeProfileData.forEach(dikeProfile => {
        let dikeProfileSingle = JSON.parse(JSON.stringify(this.format))
        dikeProfileSingle.x = dikeProfile.geometry.map(geom => geom.x)
        dikeProfileSingle.y = dikeProfile.geometry.map(geom => geom.y)
        dikeProfileSingle.name = dikeProfile.properties.name
        dikeProfileSingle.hovertemplate = dikeProfile.properties.name
        dikeProfilesPlot.push(dikeProfileSingle)
        dikeProfileSingle.line = {
          color: dikeProfile.properties.color,
          dash: 'dot',
          width: 1
        }
      })
      return dikeProfilesPlot
    },
  },
  methods: {
    setData() {
      this.$refs.plot.data = this.data
    },
    plotchart() {
      let myPlot = this.$refs.plot
      Plotly.newPlot(myPlot, this.dikeProfilesElevation, this.layout);
      return myPlot
    },
    react() {
      return Plotly.react('plot', this.dikeProfilesElevation, this.layout)
    },
    resetLine(that) {
      if (that.previousSelection) {
        that.previousSelection.line.width = that.baseLine.width
        that.previousSelection.line.dash = that.baseLine.dash
      }
    },
    highLightLine(data, that) {
      data.points[0].data.line.width = that.hoverLine.width
      data.points[0].data.line.dash = that.hoverLine.dash
      that.previousSelection = data.points[0].data
    },
  },

  async mounted() {
    let myPlot = this.plotchart();
    let that = this
    myPlot.on('plotly_hover', function (data) {
      that.resetLine(that);
      that.highLightLine(data, that);
      that.react()
    })

  }
}
</script>

<style scoped>
.col {
}
</style>